'use client';

import Link from 'next/link';
import AckoDriveLogo from '@components/atoms/AckoDriveLogo';
import { EventType, trackEventWithCommonProps } from '@utils/eventTracker';
import { usePathname } from 'next/navigation';
import { getPageNameFromUrl } from '@utils/pageNameUtils';
import { useGlobalLoader } from "@hooks/useGlobalLoader";
import { useEffect } from 'react';

interface LogoLinkProps {
  cityName: string;
  className?: string;
  logoClassName?: string;
}

export default function LogoLink({ cityName, className, logoClassName }: LogoLinkProps) {

  const pathname = usePathname();
  const { showLoader, hideLoader } = useGlobalLoader();

  useEffect(() => {
    hideLoader();
  }, [pathname, hideLoader]);
  
  const handleLogoClick = async () => {
    if (pathname != '/') {
      showLoader();
    }
    await trackEventWithCommonProps('action', EventType.TRACK_EVENT, {
      pageType: getPageNameFromUrl(pathname),
      additionalProps: {
        action_type: 'tap_btn',
        action_name: 'tap_btn_acko_drive_logo',
        city_name: cityName,
      }
    });
  };

  return (
    <Link 
      href="/" 
      className={className}
      onClick={handleLogoClick}
    >
      <AckoDriveLogo className={logoClassName} variant="dark" />
    </Link>
  );
} 